<h2 class="comp-title" style="margin-bottom: 25px;">Pop up</h2>

<button class="brand-button aqua-button" (click)="openDialog()"><span>פתח פופ אפ</span></button>

<button class="brand-button aqua-button" (click)="openDialogFull()"><span>פופ אפ מסך מלא במובייל  </span></button>